<template>
  <!-- <section> -->
  <b-row class="overflow myModal">
    <div class="mobile">
      <div class="link">
        <button class="bt btn-back" @click="goBack()">
          <font-awesome-icon :icon="['far', 'times']"/>
        </button>
        <h3>Fourchon</h3>
      </div>
      <div class="sep"></div>
    </div>

    <div class="scrollable">
      <!-- PART MIDDLE-->
      <b-col sm="12" md="12" class="column-middle">
        <!-- HEADER -->
        <b-breadcrumb :items="items" class="desktop"></b-breadcrumb>
        <div class="sep desktop"></div>
        <!-- HEADER -->
                      
        <b-card no-body class="card-big"> 
            <div class="header">
              <div class="entete">
                <h3>{{contents.thriftTitle}}</h3>
                  <!-- <PuSkeleton :loading="isLoading" :count="1" width="100px"> -->
                    <h3 class="blue mobile">
                        +15%
                    </h3>
                  <!-- </PuSkeleton> -->
              </div>

              <b-button-group>
                <b-button :pressed.sync="week">{{contents.btWeek}}</b-button>
                <b-button :pressed.sync="month">{{contents.btMonth}}</b-button>
                <b-button :pressed.sync="year">{{contents.btYear}}</b-button>
              </b-button-group>
            </div>

            <!-- CARD MINI -->
            <cardMini 
            resultOne = "540"
            resultTwo = "436"
            date = "20 mars 2019"
            dateTwo = "10 septembre 2019"
            class="mobile"
            />
            <!-- CARD MINI -->


            <!-- GRAPHIC -->
            <div class="wrapper__cardBig">
              <cardBig/>
            </div>
            <!-- GRAPHIC -->

            <!-- BUTTON PROFIL-->
            <div class="mobile">
              <wrapperCriteria 
              class="mt-4" 
              />
            </div>
            <!-- BUTTON PROFIL-->


              <btProfil 
              class="mt-4" />
        </b-card>



        <div class="list-tab">
          <h2>Agents</h2>

          <!-- TABS -->
          <listAgents 
          :lists="lists" 
          :parent="$route.params.subId"
          />
          <!-- TABS -->
        </div>

      </b-col>
      <!-- PART MIDDLE-->



      <!-- PART RIGHT -->
      <b-col sm="12" md="12" class="col-right desktop column-right borderLeft">
        <div class="relative">


        <!-- CARD MINI -->
        <cardMini 
        resultOne = "540"
        resultTwo = "436"
        date = "20 mars 2019"
        dateTwo = "10 septembre 2019"
        />
        <!-- CARD MINI -->
  
  
        <!-- CARD OBJECTIVE -->
        <cardObjective
        title = "Epargne"
        resultOne = "62 500"
        allNumber = "125 000"
        difference = "+5 000"
        date = "20 mars 2019"
        />
        <!-- CARD OBJECTIVE -->

        <div class="sep"></div>



        <!-- BUTTON ADD FAVORIS-->
          <btAddFavoris 
          :isFavorite = true
          @favorite = "checkfavorite"
          />
        <!-- BUTTON ADD FAVORIS-->

        <p class="bt-addFavoris__legal mt-2">{{contents.favorisLabel}}</p>


        <!-- BUTTON PROFIL-->
        <btProfil />
        <!-- BUTTON PROFIL-->


        <!-- BUTTON PROFIL-->
        <wrapperCriteria class="mt-4" />
        <!-- BUTTON PROFIL-->

        </div>
      </b-col>
      <!-- PART RIGHT -->
    </div>
  </b-row>
  <!-- <section> -->
</template>


<script>
import { mapGetters } from 'vuex'
import cardMini from '../../../module/card/CardMini'
import cardBig from '../../../module/card/CardBig'
import cardObjective from '../../../module/card/CardObjective'
import btProfil from '../../../module/button/btProfil'
import wrapperCriteria from '../../../module/wrapper/wrapperCriteria'
import btAddFavoris from '../../../module/button/btAddFavoris'
import listAgents from '../../../module/list/ListAgents'
import utils from '../../../Utils'

export default {
  name:"inspector",

  components:{
    cardMini,
    cardBig,
    cardObjective,
    btProfil,
    wrapperCriteria,
    btAddFavoris,
    listAgents
  },  
  data () {
      return {
          contents: [],
          lists: "",
          isMobile:false,
          isLoading:true,
          items: [
            {
              text: 'Parcourir',
              to: {name:'browseHome'}
            },
            {
              text: 'Production',
              to: {name:'life'}
            },
            {
              text: 'Nombre',
              to: {name:'subLife'},
            },
            {
              text: 'Delage',
              to: {name:'life'},
              active: true
            },
          ],
          week: true,
          month: false,
          year: false,
          isFavorite: true,
          chart : {
                  labels: [1500,1600,1700,1750,1800],
                  datasets: [{ 
                      data: [86,114,106,106,107],
                      borderColor: "rgb(0,106,162)",
                      fill: false,
                      borderDash: [5,10],
                      pointRadius: 0
                    }, { 
                      data: [282,350,411,502,635],
                      borderColor: "rgb(128,128,128)",
                      fill: false,
                      pointRadius: 0
                    }, { 
                      data: [168,170,178,190,203],
                      borderColor: "rgb(0,106,162)",
                      fill: false,
                      pointRadius: 0
                    }
                  ]
                }                    
      }
  },
  computed: {
    ...mapGetters([
      'getGeneral',
      'getListsAgents'
    ])
  },
  mounted () {
    window.scrollTo(0, 0)
  },  
  created : function (){
    this.contents = this.getGeneral;
    this.lists = this.getListsAgents;
    this.isMobile = utils.isMobile();
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)       
  },
  methods:{      
    checkfavorite (){
      console.log('ADD OR REMOVE FAVORITE');
    },
    goBack() {
      this.$store.dispatch('goBack')
      this.$router.push({name: "subLife"});  
    },    
  }   
};
</script>
